// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../native-listing-final-build/senaite.app.listing/webpack/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  position: relative;
  width: 44px;
  height: 8px;
  margin: 12px auto;
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #ccc;
  position: absolute;
}

.dot_1 {
  animation: animateDot1 1.5s linear infinite;
  left: 12px;
  background: #e579b8;
}

.dot_2 {
  animation: animateDot2 1.5s linear infinite;
  animation-delay: 0.5s;
  left: 24px;
}

.dot_3 {
  animation: animateDot3 1.5s linear infinite;
  left: 12px;
}

.dot_4 {
  animation: animateDot4 1.5s linear infinite;
  animation-delay: 0.5s;
  left: 24px;
}

@keyframes animateDot1 {
  0% {
    transform: rotate(0deg) translateX(-12px);
  }
  25% {
    transform: rotate(180deg) translateX(-12px);
  }
  75% {
    transform: rotate(180deg) translateX(-12px);
  }
  100% {
    transform: rotate(360deg) translateX(-12px);
  }
}
@keyframes animateDot2 {
  0% {
    transform: rotate(0deg) translateX(-12px);
  }
  25% {
    transform: rotate(-180deg) translateX(-12px);
  }
  75% {
    transform: rotate(-180deg) translateX(-12px);
  }
  100% {
    transform: rotate(-360deg) translateX(-12px);
  }
}
@keyframes animateDot3 {
  0% {
    transform: rotate(0deg) translateX(12px);
  }
  25% {
    transform: rotate(180deg) translateX(12px);
  }
  75% {
    transform: rotate(180deg) translateX(12px);
  }
  100% {
    transform: rotate(360deg) translateX(12px);
  }
}
@keyframes animateDot4 {
  0% {
    transform: rotate(0deg) translateX(12px);
  }
  25% {
    transform: rotate(-180deg) translateX(12px);
  }
  75% {
    transform: rotate(-180deg) translateX(12px);
  }
  100% {
    transform: rotate(-360deg) translateX(12px);
  }
}
`, "",{"version":3,"sources":["webpack://./components/Loader.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;AACA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF","sourcesContent":[".loader {\n  position: relative;\n  width: 44px;\n  height: 8px;\n  margin: 12px auto;\n}\n\n.dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n  background: #ccc;\n  position: absolute;\n}\n\n.dot_1 {\n  animation: animateDot1 1.5s linear infinite;\n  left: 12px;\n  background: #e579b8;\n}\n\n.dot_2 {\n  animation: animateDot2 1.5s linear infinite;\n  animation-delay: 0.5s;\n  left: 24px;\n}\n\n.dot_3 {\n  animation: animateDot3 1.5s linear infinite;\n  left: 12px;\n}\n\n.dot_4 {\n  animation: animateDot4 1.5s linear infinite;\n  animation-delay: 0.5s;\n  left: 24px;\n}\n\n@keyframes animateDot1 {\n  0% {\n    transform: rotate(0deg) translateX(-12px);\n  }\n  25% {\n    transform: rotate(180deg) translateX(-12px);\n  }\n  75% {\n    transform: rotate(180deg) translateX(-12px);\n  }\n  100% {\n    transform: rotate(360deg) translateX(-12px);\n  }\n}\n@keyframes animateDot2 {\n  0% {\n    transform: rotate(0deg) translateX(-12px);\n  }\n  25% {\n    transform: rotate(-180deg) translateX(-12px);\n  }\n  75% {\n    transform: rotate(-180deg) translateX(-12px);\n  }\n  100% {\n    transform: rotate(-360deg) translateX(-12px);\n  }\n}\n@keyframes animateDot3 {\n  0% {\n    transform: rotate(0deg) translateX(12px);\n  }\n  25% {\n    transform: rotate(180deg) translateX(12px);\n  }\n  75% {\n    transform: rotate(180deg) translateX(12px);\n  }\n  100% {\n    transform: rotate(360deg) translateX(12px);\n  }\n}\n@keyframes animateDot4 {\n  0% {\n    transform: rotate(0deg) translateX(12px);\n  }\n  25% {\n    transform: rotate(-180deg) translateX(12px);\n  }\n  75% {\n    transform: rotate(-180deg) translateX(12px);\n  }\n  100% {\n    transform: rotate(-360deg) translateX(12px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
